import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import Register from './views/Register'
import Dashboard from './views/Dashboard'
import SubscribeTo from "./views/SubscribeTo";
import DeviceProfile from "./views/DeviceProfile";
import NewPublication from "./views/NewPublication";

Vue.use(Router)

//Routers definition
const routers = [
    { path: '/', component: Home, name: 'home'},
    { path: '/register', component: Register, name: 'register'},
    { path: '/dashboard', component: Dashboard, name: 'dashboard', meta: { requiresAuth: true }},
    { path: '/subscribe', component: SubscribeTo, name: 'subscribe-to', meta: {requiresAuth:true}},
    { path: '/me', component: null, name: 'me-profile', meta: {requiresAuth:true}},
    { path: '/device/:device', component: DeviceProfile, name: 'device-profile', meta: {requiresAuth:true}},
    { path: '/publish', component: NewPublication, name: 'new-publication', meta: {requiresAuth:true}},
]


const router = new Router({
  mode: 'history',
  routes: routers
})
router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    if(to.meta.requiresAuth){
        const authCode = localStorage.getItem('token')
        if (authCode) {
            if(to.name === 'me-profile'){
                next('/device/' + JSON.parse(localStorage.getItem('device')).deviceName)
            }
            next()
        } else {
            next({name: 'register'})
        }
    }
    next()
})
export default router
